import React from 'react';
import PropTypes from 'prop-types';

class Schema extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			schema: 'Loading....'
		};
	}

	async componentDidMount() {
		// __APIEXAMPLEPATHS__ is a global variable from the webpack config
		// eslint-disable-next-line no-undef
		const paths = __APIEXAMPLEPATHS__;

		try {
			const resp = await fetch(`/${paths.schemaDefsPath}/${this.props.apiItem}Schema.json`);
			const data = await resp.text();

			// This throws an error if it isn't json
			JSON.parse(data);

			this.setState({ schema: data });
		}
		catch (err) {
			this.setState({ schema: 'Unable to fetch schema' });
		}
	}

	render() {
		return (
			<pre className='language-javascript'>
				<code className='language-javascript'>
					{this.state.schema}
				</code>
			</pre>
		);
	}
}

Schema.propTypes = {
	apiItem: PropTypes.string.isRequired
};

export default Schema;


// WEBPACK FOOTER //
// ./src/components/api/Schema.js